// src/components/ScrollToTop.jsx
// Scrolls the window back to the top whenever the route changes.
// Without this, React Router keeps the previous scroll position when
// navigating, so opening a service left users halfway down the page.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' in document.documentElement.style ? 'instant' : 'auto' });
        // Fallback for browsers without scrollTo options support
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname, search]);

    return null;
}

export default ScrollToTop;
